// src/components/LinkedInLogin/LinkedInLogin.tsx
import React from 'react';
import { Button } from 'antd';
import microsoftLogo from '../../../assets/images/microsoft_logo.png'

const MicrosoftLogin = () => {
  const handleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/login/microsoft`;
  };

  return (
    <Button type="default" style={{width: "100%"}} onClick={handleLogin} size={'large'}><img src={microsoftLogo} style={{width: "20px", height: "auto"}} alt="Microsoft Logo" />Continue with Microsoft</Button>
  );
};

export default MicrosoftLogin;
